const toastDurations = {
  callMissedToastDuration: 8 * 3600 * 1000, // 8h
} as const;

export default toastDurations;
